import styled from 'styled-components';

export const CompanyInfoRoot = styled.div<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor, theme }) => theme.color.white};
  padding: 5% 14.5%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 6rem 2rem;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 5rem;
  margin-top: 3rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    grid-template-columns: 2fr 1.5fr;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    grid-template-columns: 1fr 1fr;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
  }
`;

export const Image = styled.img<{ noAspectRatio?: boolean }>`
  width: 100%;
  height: 100%;
  aspect-ratio: ${({ noAspectRatio }) => (noAspectRatio ? 'unset' : '1 / 1')};
  object-fit: contain;
  border: 4px solid ${({ theme }) => theme.color.lightGrey};
  border-radiu: 0.75rem;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Subheadline = styled.p`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size22};
  margin-bottom: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width480}) {
    ${({ theme }) => theme.fontSize.size18};
`;

export const InfoFooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
  }
`;

export const TitleText = styled.h2<{ color?: string }>`
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size40};
  line-height: ${({ theme }) => theme.lineHeight.height130};
  padding-bottom: 1.2rem;
`;

export const DescriptionText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  margin-bottom: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
  }
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 160px;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color || theme.color.white};
  margin-bottom: 1rem;
`;

export const ButtonsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 60%;

  & > * {
    width: 100%;
  }

  & > * button {
    width: 100%;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;
export const PlainLink = styled.a`
  color: inherit;
  text-decoration: none;
  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: none;
  }
`;
